import { Note } from "./Note";
import { INoteProps } from "./types";

export const NoteContainer = ({ type, name, id }: INoteProps) => {
  if (!type || !id || !name) {
    return <div>Please select an element</div>;
  }
  return <Note type={type} name={name} id={id} />;
};
